import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: #fff;
    padding: 16px;
`;

export const LinkContainer = styled.div`
    display: flex;
    align-self: flex-start;
    margin-bottom: 1.5rem;
    width: 100%;
`;

export const LinkRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;

    svg {
        margin-right: 8px;
    }

    a {
        color: #333;
        font-weight: 400;
    }

    button {
        color: #333;
        font-weight: 400;
        background: transparent;
        border: none;
    }
`;

export const Title = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    padding: 1rem;

    font-size: 1.5rem;
    font-weight: 700;

    background: #f2f1f3;
    color: #333;
    border-radius: 0.5rem;
    text-transform: uppercase;
`;

export const GridTitle = styled.div`
    margin-top: 1rem;
    font-size: 1.5rem;
    text-align: center;
    font-weight: 500;
`;

export const TableContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
